import {
  dimensiondata_1_tevekenyseg_group_dimension_1_2_3_first_row_expanded_w200,
  dimensiondata_2_termekek_group_dimension_1_2_column_expanded,
  TJ_NCV_netto_value_1_precision,
  year_column_expanded,
  order_1,
  order_2
} from '../../fields';
import { PivotGridConfig } from '../../utils/pivot-grid-config';

export const kereskedelemVegsoConfig: PivotGridConfig = {
  showChart: false,
  filterYear: {numberOfYears: 1},
  options: {
    store: {
      version: 4,
      type: 'odata',
      url: 'odata/v4/public/KereskedelemVegso',
      select: ['date', 'dimension_1', 'dimension_2', 'value_1'],
      beforeSend: (e: any) => {
        e.headers = {
          Accept: 'application/json;odata.metadata=none',
        };
      },
    },
    retrieveFields: false,
    fields: [
      ...dimensiondata_1_tevekenyseg_group_dimension_1_2_3_first_row_expanded_w200,
      year_column_expanded,
      ...dimensiondata_2_termekek_group_dimension_1_2_column_expanded,
      TJ_NCV_netto_value_1_precision,
      order_1,
      order_2
    ],
  },
};
